import { Link } from 'react-router';
import { Dialog } from '../../../components/dialog-portal/dialog.tsx';
import { formatDuration } from '../../../utils/fieldFormats.ts';
import { FixMachineRow } from './autoTaskRow.ts';

interface Props {
    tasks: FixMachineRow[];
    onClose: () => void;
}

// Shows time spent being fixed, with operating machines in green.
export function FixMachinesDialog({ tasks, onClose }: Props) {
    return (
        <Dialog title='Fix in progress' onClose={onClose}>
            <div style={{ flex: '1 1 auto', minHeight: 0, overflowY: 'auto', padding: '8px 10px 12px' }}>
                <p style={{ marginTop: 0, marginBottom: 12 }}>
                    Machines being fixed: <strong>{tasks.length}</strong>
                </p>
                <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0 }}>
                    <thead>
                        <tr>
                            <th style={{ textAlign: 'left', padding: '6px 8px' }}>Coordinates</th>
                            <th style={{ textAlign: 'left', padding: '6px 8px' }}>Equipment</th>
                            <th style={{ textAlign: 'left', padding: '6px 8px' }}>Time in status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tasks.map((machine) => {
                            const color = machine.isInOperate ? 'green' : 'black';
                            return (
                                <tr key={machine.equipment} style={{ color }}>
                                    <td className='tasks--large-text' style={{ padding: '4px 8px' }}>
                                        {machine.coordinates}
                                    </td>
                                    <td className='textAlignLeft' style={{ padding: '4px 8px' }}>
                                        <Link
                                            className='link-button--non-intrusive'
                                            to={`/machine-log#equipment=${machine.equipment}`}
                                        >
                                            {machine.name}
                                        </Link>
                                    </td>
                                    <td className='tasks--large-text' style={{ padding: '4px 8px' }}>
                                        {formatDuration(machine.duration, true, false)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </Dialog>
    );
}
